import React, { useEffect, useState } from 'react';
import { format } from "d3-format";
import { arc } from "d3-shape";
import { scaleLinear } from "d3-scale";
import { Heading5 } from './Text';
import colours from './Colours';

export const Gauge = (props) => {
    let {
        value=50,
        min=0,
        max=100,
        } = props;

        const backgroundArc = arc()
            .innerRadius(0.8)
            .outerRadius(1)
            .startAngle(-Math.PI / 1.5)
            .endAngle(Math.PI / 1.5)
            .cornerRadius(1)
            ()
        const percentScale = scaleLinear()
            .domain([min, max])
            .range([0, 1])
        const percent = percentScale(value)
        const angleScale = scaleLinear()
            .domain([0, 1])
            .range([-Math.PI / 1.5, Math.PI / 1.5])
            .clamp(true)
        const angle = angleScale(percent)
        const filledArc = arc()
            .innerRadius(0.8)
            .outerRadius(1)
            .startAngle(-Math.PI / 1.5)
            .endAngle(angle)
            .cornerRadius(1)
            ()
        const colorScale = scaleLinear()
            .domain([0, 0.5, 1])
            .range(["#EF5455", "#FECE7F", "#2EB996"])
        const gradientSteps = colorScale.ticks(3)
            .map(value => colorScale(value))
        
        return (
            <div
            style={{
                textAlign: "center",
            }}>
            <svg style={{overflow: "visible"}}
                width="99%"
                height="70%"
                viewBox={[
                -1, -1,
                2, 1
                ].join(" ")}>
                <defs>
                <linearGradient
                    id="Gauge__gradient"
                    gradientUnits="userSpaceOnUse"
                    x1="-1"
                    x2="1"
                    y2="0">
                    {gradientSteps.map((color, index) => (
                    <stop
                        key={color}
                        stopColor={color}
                        offset={`${
                        index
                        / (gradientSteps.length - 1)
                        }`}
                    />
                    ))}
                </linearGradient>
                </defs>
                <path
                d={backgroundArc}
                fill={colours.primary.grey03 + '4D'} //adjust for 30% opacity in hex
                />
                <path
                d={filledArc}
                fill="url(#Gauge__gradient)"
                />
                <path
                d="M0.136364 0.0290102C0.158279 -0.0096701 0.219156 -0.00967009 0.241071 0.0290102C0.297078 0.120023 0.375 0.263367 0.375 0.324801C0.375 0.422639 0.292208 0.5 0.1875 0.5C0.0852272 0.5 -1.8346e-08 0.422639 -9.79274e-09 0.324801C0.00243506 0.263367 0.0803571 0.120023 0.136364 0.0290102ZM0.1875 0.381684C0.221591 0.381684 0.248377 0.356655 0.248377 0.324801C0.248377 0.292947 0.221591 0.267918 0.1875 0.267918C0.153409 0.267918 0.126623 0.292947 0.126623 0.324801C0.126623 0.356655 0.155844 0.381684 0.1875 0.381684Z"
                transform={`rotate(${
                    angle * (180 / Math.PI)
                }) translate(-0.2, -0.33)`}
                fill="#6a6a85"
                />
            </svg>
            {/* <Heading5 style={{marginTop: 12}}>
                { format(",")(value) }
            </Heading5> */}
            {/* {!!label && (
                <Heading5>
                    { label }
                </Heading5>
            )} */}
            </div>
        )
    };

